import styled from "styled-components";

export const Span = styled.span`  
    color: #FF0000; 
    font-family:'Poppins';
    font-weight: 500;
`;

export const Title = styled.span`    
    font-weight: 900;
`;


